import { MutableRefObject, useRef } from "react";
import { FieldValues, UseFormReturn } from "react-hook-form";

import { ServerFieldSync } from "../types";

export function useServerFieldSync({
  getValues,
  setValue,
}: Pick<UseFormReturn<FieldValues>, "getValues" | "setValue">): ServerFieldSync {
  const lastServerValues: MutableRefObject<Map<string, boolean>> = useRef(
    new Map<string, boolean>()
  );

  return (field: string, serverValue: boolean): void => {
    const isSameServerValue: boolean =
      lastServerValues.current.get(field) === serverValue;

    if (isSameServerValue && getValues(field) !== undefined) return;

    lastServerValues.current.set(field, serverValue);
    setValue(field, serverValue);
  };
}
